import base from '@/assets/js/base.js'
import entry from './entry.vue'

base.newVue({ entry });